import { Spinner } from '@globalmed/atlas-ui';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import styles from './Loader.module.css';

type TProps = {
  full?: boolean;
};

/**
 * Loader component with optional full-screen display.
 * @param props - Component props.
 * @param props.full - If true, loader will cover the full container.
 * @returns JSX element displaying a spinner.
 */
export const Loader = ({ full = false }: TProps) => {
  const { t } = useTranslation();

  return (
    <output
      className={cn(styles.loader, { [styles.full]: full })}
      aria-label={t('loading')}
    >
      <Spinner />
    </output>
  );
};
